import { Zap, HardHat, Factory, Truck, Users, Activity } from "lucide-react";
import { INDUSTRIES } from "../lib/site";

const ICONS = { Zap, HardHat, Factory, Truck, Users, Activity };

export const IndustriesSection = () => (
  <section data-testid="industries" id="industries" className="relative py-24 lg:py-32 border-t border-white/10 bg-ink-900/40">
    <div className="absolute inset-0 grid-bg-fine opacity-40" />
    <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-8 mb-12 items-end">
        <div className="lg:col-span-7">
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-cyan-400 mb-4">
            ◆ Sectors We Secure
          </p>
          <h2 className="font-display font-extrabold text-white text-3xl lg:text-5xl leading-[1.05] tracking-tighter">
            Built for the sectors<br />
            <span className="text-gradient-cyan">that can't go offline.</span>
          </h2>
        </div>
        <div className="lg:col-span-5">
          <p className="text-slate-400 leading-relaxed">
            Every industry brings unique pressure. Our consultants build site-specific solutions — from blue-light response to insurer-grade documentation.
          </p>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {INDUSTRIES.map((ind, i) => {
          const Icon = ICONS[ind.icon];
          return (
            <div
              key={ind.name}
              data-testid={`industry-${i}`}
              className="card-tech rounded-xl p-7 group cursor-default"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center group-hover:bg-cyan-500/10 group-hover:border-cyan-400/30 transition shrink-0">
                  <Icon className="w-5 h-5 text-cyan-400" />
                </div>
                <div>
                  <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 mb-1">
                    0{i + 1}
                  </div>
                  <h3 className="font-display font-bold text-white text-lg tracking-tight mb-1.5">
                    {ind.name}
                  </h3>
                  <p className="text-sm text-slate-400 leading-relaxed">{ind.desc}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
